import { render, staticRenderFns } from "./LeaveTopButtons.vue?vue&type=template&id=34ede97f"
import script from "./LeaveTopButtons.vue?vue&type=script&lang=js"
export * from "./LeaveTopButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports